/*
 * @Author: blue luo
 * @Date: 2021-07-19 11:25:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-06-18 16:41:16
 * @Description:
 */
const routes = [
  // 课程订单首页
  {
    path: "/order",
    name: "order",
    meta: {
      title: "课程订单",
      volcengine: true,
    },
    component: () => import("../pages/finance/order.vue")
  },
  // 订单详情
  {
    path: "/order/detail",
    name: "order/detail",
    meta: {
      title: "订单详情"
    },
    component: () => import("../pages/finance/order/detail.vue")
  },
  {
    path: "/order/subscribe",
    name: "order/subscribe",
    meta: {
      title: "购课"
    },
    // component: () => import("../pages/finance/courses/subscribe.vue")
    component: () => import('../pages/courseOperation/buy.vue')
  },
  {
    path: "/order/translate",
    name: "order/translate",
    meta: {
      title: "转课"
    },
    // ../pages/finance/courses/translate.vue
    component: () => import('../pages/courseOperation/transfer.vue')
  },
  {
    path: "/order/unsubscribe",
    name: "order/unsubscribe",
    meta: {
      title: "退课"
    },
    // ../pages/finance/courses/unsubscribe.vue
    component: () => import("../pages/courseOperation/refund.vue")
  },
  {
    // 结课
    path: "/order/endClassList",
    name: "order/endClassList",
    meta: {
      title: "结课"
    },
    component: () => import("../pages/finance/courses/endClassList.vue")
  },
  // 课消明细
  {
    path: "/consume",
    name: "consume",
    meta: {
      title: "课消明细",
      volcengine: true,
    },
    component: () => import("../pages/consume/record/consumeRecord.vue")
  },
];

export default routes;
